/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./normalize.css"
import "./skeleton.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
    <div class="container">
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0 1.0875rem 1.45rem`,
        }}
      >
        <main>{children}</main>
        <footer style={{
          textAlign: `center`,
          marginTop: `2rem`,
        }}>
          © {new Date().getFullYear()} 
        </footer>
      </div>


      {/* <script src="https://www.gstatic.com/firebasejs/8.0.0/firebase-app.js"></script>
      <script src="https://www.gstatic.com/firebasejs/8.0.0/firebase-analytics.js"></script>

      <script>
        // Your web app's Firebase configuration
        // For Firebase JS SDK v7.20.0 and later, measurementId is optional
        var firebaseConfig = {
          apiKey: "AIzaSyBj69JBa0QwJh9p7COVO9Bcts4nAU4qAnk",
          authDomain: "meetyouat420.firebaseapp.com",
          databaseURL: "https://meetyouat420.firebaseio.com",
          projectId: "meetyouat420",
          storageBucket: "meetyouat420.appspot.com",
          messagingSenderId: "312853584132",
          appId: "1:312853584132:web:08753b50d8d04ddd5dd851",
          measurementId: "G-P2FCK0CDH6"
        };
        // Initialize Firebase
        firebase.initializeApp(firebaseConfig);
        firebase.analytics();
      </script> */}
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
